export const orderedGraphTimeAxes = (units, field, limits) => {
  const axeX = [];
  const axeY = [];

  const redUnits = units
    .filter((unit) => unit[field] >= limits[0])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const orangeUnits = units
    .filter((unit) => unit[field] < limits[0] && unit[field] >= limits[1])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const greenUnits = units
    .filter((unit) => unit[field] < limits[1] && unit[field] >= limits[2])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const blueUnits = units
    .filter((unit) => unit[field] < limits[2] && unit[field] > limits[3])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const zeroUnits = units.filter((unit) => unit[field] === limits[3]);

  const unitsToOrder = [
    ...redUnits,
    ...blueUnits,
    ...orangeUnits,
    ...greenUnits,
    ...zeroUnits,
  ];

  unitsToOrder.forEach((unit) => {
    axeX.push(unit[field]);
    axeY.push(unit.number);
  });

  return { axeX, axeY };
};
export const orderedGraphTimeDayAxes = (units, field, limits) => {
  const axeX = [];
  const axeY = [];

  const redStrongUnits = units
    .filter((unit) => unit[field] >= limits[0])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const redUnits = units
    .filter((unit) => unit[field] < limits[0] && unit[field] >= limits[1])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const orangeUnits = units
    .filter((unit) => unit[field] < limits[1] && unit[field] >= limits[2])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const greenUnits = units
    .filter((unit) => unit[field] < limits[2] && unit[field] > limits[3])
    .sort((act, next) => {
      return next[field] - act[field];
    });
  const zeroUnits = units.filter((unit) => unit[field] === limits[3]);

  const unitsToOrder = [
    ...redStrongUnits,
    ...redUnits,
    ...orangeUnits,
    ...greenUnits,
    ...zeroUnits,
  ];

  unitsToOrder.forEach((unit) => {
    axeX.push(unit[field]);
    axeY.push(unit.number);
  });

  return { axeX, axeY };
};
